import { jsx as r } from "react/jsx-runtime";
import { CloseIcon as m } from "../Icons/basic/CloseIcon.js";
import { tv as j } from "../tailwind-variants.config.js";
const n = j({
  base: "jm-flex jm-h-6 jm-w-6 jm-items-center jm-justify-center jm-rounded-md jm-text-jutro-new-warm-gray-800 jm-transition group-hover:jm-text-jutro-new-warm-gray-950 group-focus-visible:jm-outline group-focus-visible:jm-outline-4 group-focus-visible:jm-outline-jutro-new-blue-500 group-active:jm-text-jutro-new-warm-gray-950",
  variants: {
    ghost: {
      true: "jm-bg-transparent group-hover:jm-bg-jutro-new-warm-gray-100 group-active:jm-bg-jutro-new-warm-gray-200",
      false: "jm-bg-jutro-new-warm-gray-200 group-hover:jm-bg-jutro-new-warm-gray-300 group-active:jm-bg-jutro-new-warm-gray-400"
    }
  },
  defaultVariants: {
    ghost: !0
  }
}), g = ({ onClick: t, ghost: e, ...o }) => /* @__PURE__ */ r(
  "button",
  {
    ...o,
    type: "button",
    onClick: t,
    className: "jm-group jm-flex jm-h-11 jm-w-11 jm-cursor-pointer jm-items-center jm-justify-center jm-border-none jm-bg-transparent jm-p-0 jm-outline-none lg:jm-h-fit lg:jm-w-fit",
    children: /* @__PURE__ */ r("div", { className: n({ ghost: e }), children: /* @__PURE__ */ r(m, { size: "sm" }) })
  }
);
export {
  g as NavigationButton
};
//# sourceMappingURL=index.js.map
